import clsx from "clsx";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren & {
	icon?: React.ReactNode;
	showIcon?: boolean;
	highlightText?: boolean;
};

// Below `sm` the header has the size and the spacing of the `h5` title of `FormSection`, so both tabs of the
// create sidebar look the same.
const TimeTrackingFormHeader = ({ icon, children, highlightText = false, showIcon = false }: Props) => {
	return <div className="flex flex-row items-center gap-x-3">
		{(showIcon && !!icon) ? icon : null}
		<div className={clsx("text-base font-bold tracking-tight sm:text-xl sm:tracking-normal", !highlightText ? "text-primary-500" : "text-red-500")}>{children}</div>
	</div>;
};

export default TimeTrackingFormHeader;